module.exports = __webpack_public_path__ + "static/media/sos_logo_with.c30a5fb3.png";